import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "./../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './MarketAnnouncement.css'
import Pagination from './../../../CommonUI/Pagination/Pagination';
import { useParams } from "react-router-dom";
import renderHTML from 'react-render-html';
import { useLocalStorage } from "./../../../utils/useLocalStorage";
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function MarketAnnouncement() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [nameCom, setNameCom] = useState([]);
    const [co_code, setco_code] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const [currentPage, setCurrentPage] = useState(1);
    const { getCompName } = useParams();
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [data, setData] = useState([])
    const [groupValue, setGroupValue] = useState('BSE')
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    // const [dataGroup, setDataGroup] = useState([]);
    // const [sectorName, setSectorName] = useState('00000001');
    // const [sectorNameNSE, setsectorNameNSE] = useState("00000001");


    let getData, getDataGroup;
    let PageSize = 5;
    useEffect(() => {
        setloadingshow(true)
        if (co_code != '') {
            if (groupValue === "BSE") {
                // alert(groupValue)
                const getUrl = BaseURL + "BSE_Announcement";
                fetch(`${getUrl}/${co_code}`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        setloadingshow(false)
                        //console.log(getData, "getDataBSE")
                    })
                    .catch((error) => {
                    });
            } else {
                const getUrl = BaseURL + "NSE_Announcement";

                fetch(`${getUrl}/${co_code}`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        setloadingshow(false)
                        //  console.log(getData, "getDataNSE")
                    })
                    .catch((error) => {
                    });
            }
        }

    }, [groupValue, co_code])

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);
   // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }

    // const handleClick = () => {
    //     if (groupValue === "BSE") {
    //         const getUrl = BaseURL + "PeerComparison";
    //         fetch(`${getUrl}/${groupValue}/${compCode}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);

    //                 // console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     } else {
    //         const getUrl = BaseURL + "PeerComparison";
    //         fetch(`${getUrl}/${groupValue}/${compCode}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);
    //                 //console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     }

    // }
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Announcements</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className="share-loser-sc">
                            <div className='score-header'>
                                <h2><span>Announcements</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Announcements" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            <div className="table-class">
                                <div className='share-right'>
                                    <div className='share-inner-select'>
                                        <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                            <option value="BSE">BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>
                                </div>
                               
                                <div className='Announcement-table table-responsive'>

                                    <table className='table'>
                                        {(() => {

                                            if (groupValue === "BSE") {
                                                return (
                                                    <><thead>
                                                        <tr>
                                                            <th className=''>Date</th>
                                                            <th className=''>Announcement</th>


                                                        </tr>
                                                    </thead>
                                                        <tbody>
                                                            {currentTableData && currentTableData.map(
                                                                ({ date, memo }) => (
                                                                    <tr>
                                                                        <td className="datetd">{date.split('T')[0]}</td>
                                                                        <td className="texttd">{renderHTML(memo)}</td>
                                                                    </tr>
                                                                ))}
                                                        </tbody></>
                                                )
                                            } else {
                                                return (
                                                    <><thead>
                                                        <tr>
                                                            <th className=''>Date</th>
                                                            <th className=''>Announcement</th>


                                                        </tr>
                                                    </thead>
                                                        <tbody>
                                                            {currentTableData && currentTableData.map(
                                                                ({ date, memo }) => (
                                                                    <tr>
                                                                        <td className="datetd">{date.split('T')[0]}</td>
                                                                        <td className="texttd">{renderHTML(memo)}</td>
                                                                    </tr>
                                                                ))}
                                                        </tbody></>)
                                            }

                                        })()}
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>

                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default MarketAnnouncement